
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/filters/[...slug]",
      function () {
        return require("private-next-pages/filters/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/filters/[...slug]"])
      });
    }
  